import { useState, useCallback } from "react";
import { Box, Flex } from "@chakra-ui/react";
import { useBreadcrumb } from "features/breadcrumbs";
import PageHeader from "components/Page/PageHeader";
import RelatorioDemonstrativo from "./components";
import ModalFiltros from "./components/components/ModalFiltros";
import useFiltroRelatorioReceitaDespesa from "./components/hooks/useFiltroRelatorioDespesas";
import { DespesaQuery } from "features/relatorios/typings";
import Container from "components/Container";
import { FaFilter } from "react-icons/fa";
import { AiOutlinePlus } from "react-icons/ai";
import { useDespesasPaginado } from "core/features/relatorios/hooks/useDespesasPaginado";

function RelatorioDespesaPage() {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const { filtro, onChangeFiltro } = useFiltroRelatorioReceitaDespesa();
  const [localFiltro, setLocalFiltro] = useState(filtro);

  const { data, isLoading } = useDespesasPaginado({
    ...filtro,
    limit: filtro.limit,
    page: filtro.page,
  });

  const onChangeLocalFiltro = useCallback((_filtro: Partial<DespesaQuery>) => {
    setLocalFiltro((state) => ({ ...state, ..._filtro }));
  }, []);

  const contarNumeroFiltrosAplicados = (_filtro: Partial<DespesaQuery>) => {
    return (
      (_filtro.tipoData ? 1 : 0) +
      (_filtro.pessoaId ? 1 : 0) +
      (_filtro.categoriaIds?.length || 0) +
      (_filtro.dataInicio || _filtro.dataFim ? 1 : 0) +
      (_filtro.contaBancariaIds?.length ? 1 : 0) +
      (_filtro.centrosDeCustoIds?.length ? 1 : 0) +
      (_filtro.rateioFechamentoId ? 1 : 0)
    );
  };

  const numeroFiltroSelecionados = contarNumeroFiltrosAplicados(filtro);

  const numeroFiltrosSelecionadosModal =
    contarNumeroFiltrosAplicados(localFiltro);

  useBreadcrumb([
    { name: "Relatórios" },
    { name: "Financeiro", url: "/relatorios/financeiro" },
    {
      name: "Despesas",
      url: "relatorios/financeiro/despesas",
    },
  ]);

  return (
    <Container>
      <PageHeader
        title="Relatório de despesas"
        extraButtonTitle="Filtros avançados"
        extraButtonOnClick={() => setIsOpenModal(true)}
        badge={!!numeroFiltroSelecionados}
        badgeValueExtraButton={numeroFiltroSelecionados}
        iconExtraButton={
          <>
            <FaFilter size={14} />
            <Flex right="10px" top="14px" position="absolute">
              <AiOutlinePlus size={9} />
            </Flex>
          </>
        }
      />

      <Box>
        <RelatorioDemonstrativo
          data={data}
          filtro={filtro}
          isLoading={isLoading}
          onChangeFiltro={onChangeFiltro}
          total={data?.total}
        />
      </Box>
      <ModalFiltros
        isOpenModal={isOpenModal}
        onClose={() => setIsOpenModal(false)}
        filtro={filtro}
        onChangeFiltro={onChangeFiltro}
        localFiltro={localFiltro}
        numeroFiltroSelecionados={numeroFiltrosSelecionadosModal}
        onChangeLocalFiltro={onChangeLocalFiltro}
      />
    </Container>
  );
}

export default RelatorioDespesaPage;
